// The catalog synthetic id grammar — `cat:<sha256>:<modelId>` (ADR-068): a
// canonical artifact rendered as a library row has no files row, so the id is
// built client-side from the content address plus the citing model (two models
// citing one blob — a shared brochure — must stay two distinct rows). Only the
// sha ever reaches the wire; the model segment exists for row identity alone.
export const CATALOG_FILE_PREFIX = 'cat:';
export const isCatalogFileId = (id: string): boolean => id.startsWith(CATALOG_FILE_PREFIX);
export const catalogShaOf = (id: string): string => id.slice(CATALOG_FILE_PREFIX.length).split(':')[0]!;
export const catalogFileId = (sha256: string, modelId: string): string => `${CATALOG_FILE_PREFIX}${sha256}:${modelId}`;
